<template>
  <div class="lod-fallback absolute inset-0 w-full h-full bg-zinc-800"></div>
</template>
